export const getSessionstorage = () => {
    return sessionStorage.getItem('token');
}

export const setSessionstorage = (value) => {
    sessionStorage.setItem('token', value)
}

export const removeSessionStorage = () => {
    sessionStorage.removeItem('token');
}